export default __webpack_public_path__ + "static/media/brgy_seal.f7f368ab.png";